import { useState } from "react"
import Select from 'react-select'




export const FromNoDDL = () => {
    const [FromNoDDLID, setFromNoDDLID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const optionsFromNoDDL = [
        { id: 1, value: 'प्रभाग-1' , label: 'All' },
        { id: 2, value: 'प्रभाग-2', label: 'From No. 1' },
        { id: 3, value: 'प्रभाग-3', label: 'From No. 2' },
    ]
    return (
        <>
            <Select
                id='FromNoDDLID'
                isClearable={false}
                isSearchable
                maxMenuHeight={130}
                value={{ value: FromNoDDLID.ID, label: FromNoDDLID.Label }}
                onChange={(e) => {
                    e ?
                        setFromNoDDLID({ ...FromNoDDLID, ID: e.value, Label: e.label })
                        :
                        setFromNoDDLID({ ...FromNoDDLID, ID: 0, Label: "Select..." })

                }}
                options={optionsFromNoDDL}
            />
        </>
    )
}